export default __webpack_public_path__ + "static/media/whale.698e6e5d.svg";